import { Mission } from '@/features/missions/types/mission'
import { CardRewards, CardTile } from '@/shared/ui/Card'

type MissionFeedTileProps = {
  mission: Mission
  onClick?: () => void
}

export function MissionFeedTile({ mission, onClick }: MissionFeedTileProps) {
  return (
    <CardTile key={mission.id} onClick={onClick} className="cursor-pointer">
      <img
        src={mission.imageUrl}
        alt=""
        className="size-14 lg:size-16 rounded-xl"
      />
      <div className="flex flex-col gap-1 flex-grow">
        <div className="flex items-center gap-1">
          <span className="text-white font-normal font-sans text-base">
            {mission.name}
          </span>
        </div>
        {!mission.isGeneral && (
          <div className="w-full rounded-sm bg-[#50507C] h-[22px] text-center text-white text-sm font-sans relative">
            <div
              className="absolute top-0 left-0 w-full h-full bg-primary rounded-sm"
              style={{ width: `${mission?._progress?.percentage}%` }}
            />
            <span className="absolute top-0 left-0 w-full h-full flex items-center justify-center">
              {mission?._progress?.current_count}/
              {mission?._progress?.total_count}
            </span>
          </div>
        )}
      </div>
    </CardTile>
  )
}
